const tailwindColors = require("tailwindcss/colors");

export const allColors500 = Object.values(tailwindColors)
  .map((color) => color[500])
  .filter((i) => i);

export const randomColors = (count) => {
  const shuffled = [...allColors500].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};
